import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "16.95",
  height: "12.95",
  x: "3.525",
  y: "5.136",
  stroke: "currentColor",
  "stroke-width": "1.05",
  rx: "1.475"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.05",
  d: "m4 5.611 7.476 4.398A2 2 0 0 0 13.519 10L20 6.111"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }